export class SpreadMetricModel {
  ct!: number;
  d!: number;
  pc!: number;
  ver!: number;
  /**
   * Contains calculated value for radar,
   * value in range in between 0 and 1
   */
  gmc!: number;
}

export default class SpreadMetric extends SpreadMetricModel {
  constructor({ ct, d, pc, ver, gmc }: SpreadMetricModel) {
    super();

    this.ct = ct;
    this.d = d;
    this.pc = pc;
    this.ver = ver;
    this.gmc = gmc;
  }
}
